import React from "react";
// nodejs library that concatenates classes

import PropTypes from "prop-types";
// @material-ui/core components
import { Box } from "@mui/material";

// core components
import styles from "../../assets/jss/material-dashboard-react/components/cardStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function Card(props) {
  const { className, children, plain, profile, chart, sx, ...rest } = props;

  const targetData = ({
    "card": true,
    "cardPlain": plain,
    "cardProfile": profile,
    "cardChart": chart
  });

  const keyArray = getKeyArray(targetData);

  let style = getBaseSxStyle(styles, keyArray);

  if (sx) {
    style = {
      ...style,
      ...sx
    };
  };


  return (
    <Box sx={style} {...rest}>
      {children}
    </Box>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  chart: PropTypes.bool,
  children: PropTypes.node
};
